'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _validation = require('@marmalade/form/lib/actions/validation');
var _isInternal = require('@marmalade/is-internal');
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _constants = require('../../constants');
var _actions = require('../../quote/actions');
var _constants2 = require('../constants');
var _charity = require('../selectors/charity');
var _payByTelephoney = require('../selectors/pay-by-telephoney');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
exports.default = function (theme) {
  return function () {
    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
      var policyCover, formCover, initialPrice, updatedPrice, res;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              policyCover = getState().ldiQuote.policy.cover;
              formCover = getState().form.newBusinessStage4.values.cover;
              initialPrice = getState().ldiQuote.quotes.find(function (quote) {
                return String(quote.cover) === formCover;
              }).premium;
              if (!(policyCover !== formCover)) {
                _context.next = 10;
                break;
              }
              _context.next = 6;
              return dispatch((0, _actions.fetchFullQuote)(theme, true));
            case 6:
              updatedPrice = getState().ldiQuote.quotes.find(function (quote) {
                return String(quote.cover) === formCover;
              }).premium;
              if (!(initialPrice !== updatedPrice)) {
                _context.next = 10;
                break;
              }
              dispatch((0, _validation.validateFieldAction)(_constants2.stages[3].formId, 'priceChange', 'Your prices have been updated, please check and try again.'));
              return _context.abrupt('return');
            case 10:
              dispatch((0, _validation.validateFieldAction)(_constants2.stages[3].formId, 'priceChange'));
              _context.next = 13;
              return _axios2.default.post(process.env.REACT_APP_API_BASE_URI + '/ldi/v1/public/payment', Object.assign({
                policyId: getState().ldiQuote.policy.id,
                loginId: getState().ldiQuote.policy.login.id,
                idHash: getState().ldiQuote.policy.idHash,
                donation: (0, _charity.donation)(getState()),
                giftAid: (0, _charity.giftAid)(getState())
              }, !_constants.IS_LIVE_SITE && (0, _isInternal.isInternal)(getState()) ? {
                useTelephony: (0, _payByTelephoney.payByTelephony)(getState())
              } : null));
            case 13:
              res = _context.sent;
              document.location.assign(res.data.redirect);
            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};